// extracted by mini-css-extract-plugin
export default {"oneTwoGrid":"analytics_oneTwoGrid__MmwNH","twoOneGrid":"analytics_twoOneGrid__LLoDP","oneOneGrid":"analytics_oneOneGrid__b2JY1","page":"analytics_page__ZsEEI"};